/**
 * RoomPresenceSystem.js
 * Tracks local player's current Room (RoomX, RoomZ) in the infinite grid.
 * Fires events when the player transitions from one room to another.
 */
export class RoomPresenceSystem {
  constructor(sectorSize = 20) {
    this.sectorSize = sectorSize;
    this.currentRoomX = null;
    this.currentRoomZ = null;
    this.onRoomChangeCallback = null;
  }

  /**
   * Main coordinate polling update.
   * Compares the current player position against the active Room coords.
   * @param {THREE.Vector3} position - Local player camera position
   */
  update(position) {
    if (!position) return;

    // Standard FRONTROOMS Room mapping: 20mx20m chunks centered around (gx * 20, gz * 20)
    // The main game does: gx = Math.floor((px + 10) / 20), gz = Math.floor((pz + 10) / 20)
    const rx = Math.floor((position.x + 10) / this.sectorSize);
    const rz = Math.floor((position.z + 10) / this.sectorSize);

    if (this.currentRoomX === null || this.currentRoomZ === null) {
      // First boot assignment
      this.currentRoomX = rx;
      this.currentRoomZ = rz;
      console.log(`[RoomPresenceSystem] Initial Room Spawn: [X: ${rx}, Z: ${rz}]`);
      if (this.onRoomChangeCallback) {
        this.onRoomChangeCallback(rx, rz);
      }
    } else if (this.currentRoomX !== rx || this.currentRoomZ !== rz) {
      // Transition detected
      const oldX = this.currentRoomX;
      const oldZ = this.currentRoomZ;
      this.currentRoomX = rx;
      this.currentRoomZ = rz;
      console.log(`[RoomPresenceSystem] Room Transition: [X: ${oldX}, Z: ${oldZ}] -> [X: ${rx}, Z: ${rz}]`);
      if (this.onRoomChangeCallback) {
        this.onRoomChangeCallback(rx, rz);
      }
    }
  }

  /**
   * Resets active tracking states.
   */
  reset() {
    this.currentRoomX = null;
    this.currentRoomZ = null;
  }
}
